import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "row-top w-full h-full" }
const _hoisted_2 = {
  class: "sub-menu scrollbox",
  style: {"width":"24rem"}
}
const _hoisted_3 = { class: "w-full h-full content-transparent" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  key: 0,
  class: "mbottom-20"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row pad-s mleft-01" }
const _hoisted_9 = { class: "font-mBold main-l" }
const _hoisted_10 = { class: "font-m main-l pad-s mleft-02" }
const _hoisted_11 = { class: "mleft-10 colCenter" }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  key: 2,
  class: "mtop-01"
}
const _hoisted_14 = {
  key: 3,
  class: "mtop-10"
}

import taskCard from './taskCard.vue'
import taskBoxColumn from './taskBoxColumn.vue'

import { apiDate } from "@/api/apicommon"
import { ref, computed, onMounted, Ref } from 'vue'
import { useAppUserStore } from '@/stores/appUser'
import { usePermissionsStore } from "@/stores/permissionsStore";
import router from '@/router'
import officeapi from "@/api/officeapi"
import { useI18n } from 'vue-i18n'
import { useUiStore } from "@/stores/ui";
import { GetTaskByStatusRequest, Pageable, TaskApi, TaskResponsePaginated } from '@/apiGenerate/medserver'
import { medServerApiConfig } from '@/config/medserver-api.config'
import { TaskGroup, TaskPriorityChange, TaskPriorityType, TaskStatus, TaskStatusChange } from '@/models/task.model'
import { PageableDefault } from '@/models/share.model'
import EsPaginator from '@/components/share/esPaginator.vue';
import loadingSpinner from "@/views/loadingSpinner.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'dashbTasks',
  setup(__props) {

const uiStore = useUiStore();

const appUserStore = useAppUserStore();
const permissionsStore = usePermissionsStore();
const taskApi = new TaskApi(medServerApiConfig);

const { t } = useI18n();

const tasksRename = ref<TaskResponsePaginated>({
  tasks: [],
  pageable: PageableDefault,
  totalCount: 0
});
const tasksSettled = ref<TaskResponsePaginated>({
  tasks: [],
  pageable: PageableDefault,
  totalCount: 0
});
const tasksPendingNone = ref<TaskResponsePaginated>({
  tasks: [],
  pageable: PageableDefault,
  totalCount: 0
});
const tasksPendingNextDays = ref<TaskResponsePaginated>({
  tasks: [],
  pageable: PageableDefault,
  totalCount: 0
});
const tasksPendingEndOfShift = ref<TaskResponsePaginated>({
  tasks: [],
  pageable: PageableDefault,
  totalCount: 0
});
const tasksPendingDuringShift = ref<TaskResponsePaginated>({
  tasks: [],
  pageable: PageableDefault,
  totalCount: 0
});
const tasksPendingFuture = ref<TaskResponsePaginated>({
  tasks: [],
  pageable: PageableDefault,
  totalCount: 0
});

const loadingAllTasks = ref<boolean>(false);
const loadingGroupKey = ref<string>("");

const showValidated = ref<boolean>(false);
const showFuture = ref<boolean>(false);
const showRename = ref<boolean>(false);

async function checkPermission() {
  const hasAccess = await permissionsStore.checkPermission("ACCESS_TASK");
  if (!hasAccess) {
      router.push('/error?error=USER_FORBIDDEN');
  }
}


const getTasksByStatusAndProrityType = async (status: string, priorityType: string, pageable: Pageable, signal?: AbortSignal) => {
  const params: GetTaskByStatusRequest = { status, priorityType, start: pageable.start, limit: pageable.limit };
  if (uiStore.currTaskBoxId ) {
    params.taskBoxUuid = uiStore.currTaskBoxId ;
  }
  return await taskApi.getTaskByStatus(params, signal ? { signal } : undefined);
}

const getTasksByStatusPaginated = async (status: string, pageable: Pageable, signal?: AbortSignal) => {
  const params: GetTaskByStatusRequest = { status, start: pageable.start, limit: pageable.limit };
  if (uiStore.currTaskBoxId ) {
    params.taskBoxUuid = uiStore.currTaskBoxId ;
  }
  return await taskApi.getTaskByStatus(params, signal ? { signal } : undefined);
}

const getFutureTasks = async (pageable: Pageable, signal?: AbortSignal) => {
  const params: GetTaskByStatusRequest = { status: TaskStatus.Pending, futureTasks: true, start: pageable.start, limit: pageable.limit };
  if (uiStore.currTaskBoxId ) {
    params.taskBoxUuid = uiStore.currTaskBoxId ;
  }
  return await taskApi.getTaskByStatus(params, signal ? { signal } : undefined);
}

// Map each taskGroup to its ref and fetch function
const taskGroupMap: Record<string, { ref: Ref<TaskResponsePaginated>; fetch: (pageable: Pageable, signal?: AbortSignal) => Promise<TaskResponsePaginated> }> = {
  [TaskStatus.Rename]: {
    ref: tasksRename,
    fetch: (p, signal) => getTasksByStatusPaginated(TaskStatus.Rename, p, signal),
  },
  [TaskStatus.Pending]: {
    ref: tasksPendingFuture,
    fetch: (p, signal) => getFutureTasks(p, signal),
  },
  [TaskPriorityType.None]: {
    ref: tasksPendingNone,
    fetch: (p, signal) => getTasksByStatusAndProrityType(TaskStatus.Pending, TaskPriorityType.None, p, signal),
  },
  [TaskPriorityType.DuringShift]: {
    ref: tasksPendingDuringShift,
    fetch: (p, signal) => getTasksByStatusAndProrityType(TaskStatus.Pending, TaskPriorityType.DuringShift, p, signal),
  },
  [TaskPriorityType.EndOfShift]: {
    ref: tasksPendingEndOfShift,
    fetch: (p, signal) => getTasksByStatusAndProrityType(TaskStatus.Pending, TaskPriorityType.EndOfShift, p, signal),
  },
  [TaskPriorityType.NextDays]: {
    ref: tasksPendingNextDays,
    fetch: (p, signal) => getTasksByStatusAndProrityType(TaskStatus.Pending, TaskPriorityType.NextDays, p, signal),
  },
  [TaskStatus.Settled]: {
    ref: tasksSettled,
    fetch: (p, signal) => getTasksByStatusPaginated(TaskStatus.Settled, p, signal),
  },
};

const updateTaskStore = () => {
  const allTasks = Object.values(taskGroupMap).flatMap(g => g.ref.value.tasks);
  appUserStore.setTaskList(allTasks);
}

let currentAbortController: AbortController | null = null;

const loadSingleGroup = async (key: string) => {
  const config = taskGroupMap[key];
  if (!config) return;

  loadingGroupKey.value = key;
  try {
    config.ref.value = await config.fetch(config.ref.value.pageable);
    updateTaskStore();
  } finally {
    loadingGroupKey.value = "";
  }
}

const taskGroupOrder = [
  TaskStatus.Rename,
  TaskPriorityType.DuringShift,
  TaskPriorityType.EndOfShift,
  TaskPriorityType.NextDays,
  TaskPriorityType.None,
  TaskStatus.Pending,
  TaskStatus.Settled,
];

const loadAllTasks = async (taskUpdated: any | undefined, taskPriorityChange: TaskPriorityChange | undefined, taskStatusChange: TaskStatusChange | undefined) => {
  if (currentAbortController) {
    currentAbortController.abort();
  }
  currentAbortController = new AbortController();
  const signal = currentAbortController.signal;

  const keysToFetch = taskGroupOrder.filter(key =>
    (!taskUpdated || key === taskUpdated.taskPriorityType || key === taskUpdated.taskStatus) 
    || (taskPriorityChange && (key === taskPriorityChange.oldPriority || key === taskPriorityChange.newPriority))
    || ((taskStatusChange && (key === taskStatusChange.oldStatus || key === taskStatusChange.newStatus)))
  );
  //Backend
  const results = await Promise.allSettled(
    keysToFetch.map(key => taskGroupMap[key].fetch(taskGroupMap[key].ref.value.pageable, signal))
  );
  //Frontend
  keysToFetch.forEach((key, i) => {
    const result = results[i];
    if (result.status === 'fulfilled') {
      taskGroupMap[key].ref.value = result.value;
    } else if (!signal.aborted) {
      console.error(`Error fetching group "${key}":`, result.reason);
    }
  });
  updateTaskStore();
}

const prevPageable = async (key: string) => {
  const config = taskGroupMap[key];
  if (!config) return;
  config.ref.value.pageable.start -= config.ref.value.pageable.limit;
  await loadSingleGroup(key);
}

const nextPageable = async (key: string) => {
  const config = taskGroupMap[key];
  if (!config) return;
  config.ref.value.pageable.start += config.ref.value.pageable.limit;
  await loadSingleGroup(key);
}

async function loadTasksAndBoxes() {
  loadingAllTasks.value = true;
  try {
    await loadAllTasks(undefined, undefined, undefined);
  } finally {
    loadingAllTasks.value = false;
  }

  await appUserStore.setTaskBoxList();
}

async function loadTasksAndBoxesFiltered(taskUpdated: any, data: {taskPriorityChange: TaskPriorityChange, taskStatusChange: TaskStatusChange}) {
  loadingAllTasks.value = true;
  try {
    await loadAllTasks(taskUpdated, data.taskPriorityChange, data.taskStatusChange);
  } finally {
    loadingAllTasks.value = false;
  }

  await appUserStore.setTaskBoxList();
}

async function changeTaskBox(newTaskBoxId: string) {
  uiStore.setCurrTaskBoxId(newTaskBoxId);
  loadingAllTasks.value = true;
  try {
    await loadAllTasks(undefined, undefined, undefined);
  } finally {
    loadingAllTasks.value = false;
  }
}

const createTaskGroup = (key: string, text: string): TaskGroup => {
  return {
    key: key,
    text: text,
    tasks: [],
    isResults: false,
    pageable: undefined,
    totalCount: 0
  }
}

const filteredTaskList = computed(() => {
  if (!appUserStore.taskBoxList) return [];

  const priorityGroups = [];

  const duringShiftTasks = createTaskGroup(TaskPriorityType.DuringShift, t('task.taskPriority.DuringShift'));
  const endOfShiftTasks = createTaskGroup(TaskPriorityType.EndOfShift, t('task.taskPriority.EndOfShift'));
  const nextDaysTasks = createTaskGroup(TaskPriorityType.NextDays, t('task.taskPriority.NextDays'));
  const noneTasks = createTaskGroup(TaskPriorityType.None, t('task.taskPriority.None'));
  const settledTasks = createTaskGroup(TaskStatus.Settled, t('task.status.Settled'));
  const futureTasks =  createTaskGroup(TaskStatus.Pending, t('task.status.Pending'));
  const renameTasks =  createTaskGroup(TaskStatus.Rename, t('task.status.Rename'));

  //Set visibility
  if (uiStore.currTaskBoxId) {
    const allTaskBoxes = [...appUserStore.taskBoxAssigneeList, ...appUserStore.taskBoxNonAssigneeList, ...appUserStore.taskBoxTwoPersonList]
    const currFullTaskBox = allTaskBoxes.find(taskBox => taskBox.taskBoxId == uiStore.currTaskBoxId )
    if (currFullTaskBox.taskBoxChannelType === 'Results') {renameTasks.isResults = true}
  }

  futureTasks.tasks = tasksPendingFuture.value.tasks ?? [];
  futureTasks.pageable = tasksPendingFuture.value.pageable ?? undefined;
  futureTasks.totalCount = tasksPendingFuture.value.totalCount ?? 0;

  duringShiftTasks.tasks = tasksPendingDuringShift.value.tasks ?? [];
  duringShiftTasks.pageable = tasksPendingDuringShift.value.pageable ?? undefined;
  duringShiftTasks.totalCount = tasksPendingDuringShift.value.totalCount ?? 0;

  endOfShiftTasks.tasks = tasksPendingEndOfShift.value.tasks ?? [];
  endOfShiftTasks.pageable = tasksPendingEndOfShift.value.pageable ?? undefined;
  endOfShiftTasks.totalCount = tasksPendingEndOfShift.value.totalCount ?? 0;

  nextDaysTasks.tasks = tasksPendingNextDays.value.tasks ?? [];
  nextDaysTasks.pageable = tasksPendingNextDays.value.pageable ?? undefined;
  nextDaysTasks.totalCount = tasksPendingNextDays.value.totalCount ?? 0;

  noneTasks.tasks = tasksPendingNone.value.tasks ?? [];
  noneTasks.pageable = tasksPendingNone.value.pageable ?? undefined;
  noneTasks.totalCount = tasksPendingNone.value.totalCount ?? 0;

  renameTasks.tasks = tasksRename.value.tasks ?? [];
  renameTasks.pageable = tasksRename.value.pageable ?? undefined;
  renameTasks.totalCount = tasksRename.value.totalCount ?? 0;

  settledTasks.tasks = tasksSettled.value.tasks ?? [];
  settledTasks.pageable = tasksSettled.value.pageable ?? undefined;
  settledTasks.totalCount = tasksSettled.value.totalCount ?? 0;

  priorityGroups.push(renameTasks);
  priorityGroups.push(duringShiftTasks);
  priorityGroups.push(endOfShiftTasks);
  priorityGroups.push(nextDaysTasks);
  priorityGroups.push(noneTasks);
  priorityGroups.push(futureTasks);
  priorityGroups.push(settledTasks);

  priorityGroups.forEach((group) => {
    group.tasks = group.tasks.sort((a, b) => apiDate(b.created) - apiDate(a.created) || b.taskId - a.taskId)
  })

  return priorityGroups
})


function onDropOnFilter(e) {
  e.preventDefault();
  e.stopPropagation();  
  const files = e.dataTransfer.files;
  if (files.length > 0) {
    importFilesChangedFCT(files);
  }
}

const isDropZoneActive = ref(false);

function onDragOverFilter() {
  isDropZoneActive.value = true;
}

function onDragLeaveFilter() {
  isDropZoneActive.value = false;
}

async function importFilesChangedFCT(files) {
  const taskBoxId = uiStore.currTaskBoxId ;
  isDropZoneActive.value = false
  await officeapi.addImportFilesAsTasks(taskBoxId, files);
  loadTasksAndBoxes();
}

const validKeyForDisplayPagination = (key: string) => {
  return (TaskStatus.Rename === key && showRename.value) || (TaskStatus.Settled === key && showValidated.value) || (TaskStatus.Pending === key && showFuture.value) 
        || Object.values(TaskPriorityType).includes(key);
}

onMounted(async () => {
  await checkPermission();
  await loadTasksAndBoxes();
})

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_file_upload = _resolveComponent("file-upload")!
  const _component_itemScroll = _resolveComponent("itemScroll")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(taskBoxColumn, {
        startTaskBox: _unref(uiStore).currTaskBoxId,
        isMainMenu: true,
        showMessageCount: true,
        showTaskBoxSettings: true,
        onReload: _cache[0] || (_cache[0] = ($event: any) => (loadTasksAndBoxes())),
        onChangeTaskBox: changeTaskBox,
        onAfterDeactivateTaskBox: _cache[1] || (_cache[1] = ($event: any) => (changeTaskBox('')))
      }, null, 8, ["startTaskBox"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_itemScroll, {
        class: "col",
        style: {"height":"93vh","margin-left":"5rem"}
      }, {
        default: _withCtx(() => [
          (loadingAllTasks.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createVNode(loadingSpinner, {
                  logo: false,
                  style: 'w-3'
                })
              ]))
            : (filteredTaskList.value.every(group => !group.tasks.length && !group.isResults))
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_text_item, {
                    txt: _unref(t)('task.emptyState'),
                    styles: "font-mBold main-l"
                  }, null, 8, ["txt"])
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(filteredTaskList.value, (taskGroup, index) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                    (taskGroup.tasks.length || taskGroup.isResults)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, [
                              _createElementVNode("span", _hoisted_9, _toDisplayString(taskGroup.text), 1),
                              _createElementVNode("span", _hoisted_10, "(" + _toDisplayString(taskGroup.totalCount) + ")", 1)
                            ]),
                            ((taskGroup.key === _unref(TaskStatus).Settled))
                              ? (_openBlock(), _createBlock(_component_button_group, {
                                  key: 0,
                                  onClick: _cache[2] || (_cache[2] = ($event: any) => (showValidated.value = !showValidated.value))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_item, {
                                      icon: showValidated.value ? 'chevronsDown' : 'chevronsUp',
                                      styles: "size-m main-m"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            ((taskGroup.key === _unref(TaskStatus).Pending))
                              ? (_openBlock(), _createBlock(_component_button_group, {
                                  key: 1,
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (showFuture.value = !showFuture.value))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_item, {
                                      icon: showFuture.value ? 'chevronsDown' : 'chevronsUp',
                                      styles: "size-m main-m"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true),
                            ((taskGroup.key === _unref(TaskStatus).Rename))
                              ? (_openBlock(), _createBlock(_component_button_group, {
                                  key: 2,
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (showRename.value = !showRename.value))
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_item, {
                                      icon: showRename.value ? 'chevronsDown' : 'chevronsUp',
                                      styles: "size-m main-m"
                                    }, null, 8, ["icon"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          (_unref(uiStore).currTaskBoxId && taskGroup.key === _unref(TaskStatus).Rename && showRename.value)
                            ? (_openBlock(), _createBlock(_component_file_upload, {
                                key: 0,
                                id: "importFiles",
                                multiple: "",
                                onFilesChanged: _cache[8] || (_cache[8] = (files) => importFilesChangedFCT(files)),
                                class: "w-full"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["dropzone rowcenter", isDropZoneActive.value ? 'dropzone-drag-over bigshadow' : '']),
                                    style: {"margin-bottom":"0.6rem","margin-top":"0.6rem"},
                                    onDrop: _cache[5] || (_cache[5] = _withModifiers((event) => onDropOnFilter(event), ["prevent"])),
                                    onDragover: _cache[6] || (_cache[6] = _withModifiers(($event: any) => (onDragOverFilter()), ["prevent"])),
                                    onDragleave: _cache[7] || (_cache[7] = ($event: any) => (onDragLeaveFilter()))
                                  }, [
                                    _createVNode(_component_svg_item, {
                                      icon: "upload",
                                      styles: "main-m size-l"
                                    }),
                                    _createElementVNode("div", _hoisted_11, [
                                      _createVNode(_component_text_item, {
                                        txt: _unref(t)('task.dropzone.title'),
                                        styles: "font-m"
                                      }, null, 8, ["txt"]),
                                      _createVNode(_component_text_item, {
                                        txt: _unref(t)('task.dropzone.subtitle'),
                                        styles: "main-m"
                                      }, null, 8, ["txt"])
                                    ])
                                  ], 34)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (loadingGroupKey.value === taskGroup.key)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                _createVNode(loadingSpinner, {
                                  logo: false,
                                  style: 'w-3'
                                })
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                (!(taskGroup.key === _unref(TaskStatus).Settled && !showValidated.value) && !(taskGroup.key === _unref(TaskStatus).Pending && !showFuture.value)  && !(taskGroup.key === _unref(TaskStatus).Rename && !showRename.value))
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(taskGroup.tasks, (task) => {
                                      return (_openBlock(), _createBlock(taskCard, {
                                        key: task.taskId,
                                        task: task,
                                        tasks: taskGroup.tasks,
                                        onChanged: ($event: any) => (loadTasksAndBoxesFiltered(task, $event)),
                                        onChangeShowDate: _cache[9] || (_cache[9] = ($event: any) => (loadAllTasks(undefined, undefined, undefined)))
                                      }, null, 8, ["task", "tasks", "onChanged"]))
                                    }), 128))
                                  : _createCommentVNode("", true)
                              ])),
                          (validKeyForDisplayPagination(taskGroup.key) && taskGroup.pageable && taskGroup.totalCount > taskGroup.pageable.limit)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createVNode(EsPaginator, {
                                  currentRef: 'paginator-bottom-' + taskGroup.key,
                                  pageable: taskGroup.pageable,
                                  total: taskGroup.totalCount,
                                  loading: loadingAllTasks.value || loadingGroupKey.value === taskGroup.key,
                                  onPrevPage: ($event: any) => (prevPageable(taskGroup.key)),
                                  onNextPage: ($event: any) => (nextPageable(taskGroup.key))
                                }, null, 8, ["currentRef", "pageable", "total", "loading", "onPrevPage", "onNextPage"])
                              ]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ], 64))
                }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}
}

})